import { redirect } from '@tanstack/react-router';
import useAppStore from '../../../store/rootStore.ts';

export function tournamentBeforeLoad() {
  const config = useAppStore.getState().config;
  if (!config?.features.tournamentEnabled || !config.competitions?.length) {
    throw redirect({ to: '/trade', replace: true });
  }
}
